import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/WhaleShark/report/updateItem";
import useGetDetailItem from "@hooks/Clients/WhaleShark/report/useGetReport";
import validator from "@validators/Clients/WhaleShark/report/Report.validate";
import formMapper from "@mappers/Clients/WhaleShark/report/ReportItem.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
